var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33341 1.85416H7.85425L10.2917 4.29166V10.5208C10.2917 10.6645 10.2347 10.8023 10.1331 10.9038C10.0315 11.0054 9.89374 11.0625 9.75008 11.0625H4.33341C4.18976 11.0625 4.05198 11.0054 3.9504 10.9038C3.84882 10.8023 3.79175 10.6645 3.79175 10.5208V2.39582C3.79175 2.25216 3.84882 2.11439 3.9504 2.01281C4.05198 1.91122 4.18976 1.85416 4.33341 1.85416ZM9.47925 4.29166L7.85425 2.66666V4.02082C7.85425 4.09265 7.88278 4.16154 7.93357 4.21233C7.98436 4.26312 8.05325 4.29166 8.12508 4.29166H9.47925ZM8.85823 6.26684C8.909 6.31763 8.93752 6.38651 8.93752 6.45832C8.93752 6.53014 8.909 6.59901 8.85823 6.6498L6.50008 9.00795L5.22527 7.73314C5.17593 7.68206 5.14864 7.61364 5.14925 7.54263C5.14987 7.47162 5.17835 7.40369 5.22857 7.35348C5.27878 7.30326 5.34671 7.27478 5.41772 7.27416C5.48873 7.27354 5.55715 7.30084 5.60823 7.35018L6.50008 8.24203L8.47527 6.26684C8.52606 6.21607 8.59493 6.18755 8.66675 6.18755C8.73856 6.18755 8.80744 6.21607 8.85823 6.26684Z",
    fill: "#673C8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25004 3.47916H2.70837V10.7917C2.70837 11.1508 2.85104 11.4952 3.105 11.7492C3.35896 12.0032 3.70339 12.1458 4.06254 12.1458H9.20837V11.6042H4.06254C3.84705 11.6042 3.64039 11.5186 3.48802 11.3662C3.33564 11.2138 3.25004 11.0071 3.25004 10.7917V3.47916Z",
    fill: "#673C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptable);
export default __webpack_public_path__ + "static/media/acceptable.da290957d216a568527c4c5b20fb633a.svg";
export { ForwardRef as ReactComponent };